module.exports = __webpack_public_path__ + "img/zenbu-dark.e9f43377.png";